<app-navbar title="Grupy ofert">
	<button class="me-4" mat-raised-button color="primary" routerLink="./add">
		<i class="fas fa-plus"></i>
		Dodaj
	</button>
</app-navbar>

<div class="row filters-row m-2">
	<div class="col-md-10">
		<input
			type="text"
			class="form-control w-100"
			(keyup)="refreshFilter()"
			[(ngModel)]="filterValue"
			placeholder="Filtrowanie (min. 3 znaki)"
		/>
	</div>
	<div class="col-md-2 text-center">
		<button class="me-4" mat-raised-button color="primary" (click)="filtersOpen()">
			<i class="fas fa-filter"></i>
		</button>
	</div>
</div>
<app-group-offer-list-filters
	userFilters="group_offers"
	[yesno]="parameters.yesno"
	[products]="parameters.products"
	[locations]="parameters.locations"
	(selected)="filtersSelected($event)"
	[forceFilters]="{ limit: 9999 }"
></app-group-offer-list-filters>

<ng-container *ngIf="showTable">
	<mat-table
		[dataSource]="matData"
		matSort
		matSortActive="id"
		matSortDirection="asc"
		grouping="false"
		cdkDropList
		cdkDropListDisabled="true"
	>
		<ng-container matColumnDef="id">
			<mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.id }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="name">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big"> Nazwa oferty </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">{{ element.name }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="locations">
			<mat-header-cell *matHeaderCellDef class="mat-cell-big"> Lokalizacje </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">
				<div class="d-grid me-2">
					<span class="mt-1" *ngFor="let funct of removeDuplicates(element.locations).slice(0, 2)">{{
						funct
					}}</span>
				</div>

				<button
					mat-mini-fab
					color="primary"
					class="my-1 disabled"
					*ngIf="element.locations.length > 2"
					matTooltip="{{ removeDuplicates(element.locations).slice(2) }}"
				>
					+ {{ removeDuplicates(element.locations).length - 2 }}
				</button>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="groupProducts">
			<mat-header-cell *matHeaderCellDef class="mat-cell-big"> Produkty </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">
				<div class="d-grid me-2">
					<span class="mt-1" *ngFor="let funct of element.groupProducts.slice(0, 2)">{{
						funct.product.name
					}}</span>
				</div>

				<button
					mat-mini-fab
					class="my-1 disabled"
					*ngIf="element.groupProducts.length > 2"
					matTooltip="{{ element.tooltipProducts.slice(2) }}"
				>
					+ {{ element.groupProducts.length - 2 }}
				</button>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="date-range">
			<mat-header-cell *matHeaderCellDef class="mat-cell-big"> Od - Do </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">
				<ng-container *ngIf="element.dateRange.lower || element.dateRange.upper">
					{{ element.dateRange.lower }} -
					{{ element.dateRange.upper }}
				</ng-container>
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="edit">
			<mat-header-cell *matHeaderCellDef></mat-header-cell>
			<mat-cell *matCellDef="let element">
				<button mat-raised-button color="primary" routerLink="/groupOffer/{{ element.id }}/">Edytuj</button>
			</mat-cell>
		</ng-container>
		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag></mat-row>
	</mat-table>
	<div class="footer">
		<mat-paginator
			[pageSizeOptions]="[10, 20, 50]"
			[pageSize]="50"
			showFirstLastButtons
			aria-label="Select page of periodic elements"
		>
		</mat-paginator>
	</div>
</ng-container>
<ng-container *ngIf="!showTable">
	<div class="h-100 d-flex flex-column">
		<div class="no-results-container d-flex flex-column">
			<i class="fa-solid fa-face-sad-tear fa-6x"></i>
			<p class="mt-5">Nie znaleziono grup ofert</p>
			<p>Wyczyść filtry lub dodaj ofertę</p>
		</div>
	</div>
</ng-container>
